__turbopack_context__.v({
  "gloss": "gloss-module__vZJMIq__gloss",
  "tip": "gloss-module__vZJMIq__tip",
});
